export default __webpack_public_path__ + "654feef4b32c7aaa6e058324f3da24a0.png";